import React from 'react';
import Sidebar from '../components/Layouts/Sidebar';
import Bottom from '../components/Layouts/Bottom';
import CreatePostStepTwo from '../components/Post/CreatePostStepTwo';
import CreateContentSidebar from '../components/Layouts/Sidebar/Content';

const CreateContentStepTwo = () => {
  return (
    <>
      <div className="full-sec">
        <div className="left-sec col-md-3">
          <CreateContentSidebar />
        </div>

        <div className="right-sec creat-right-sec col-md-9">
          <CreatePostStepTwo />
        </div>
      </div>
      <Bottom />
    </>
  );
};

export default CreateContentStepTwo;
